import create from 'zustand'

import { InternalError } from '@frame/lib/errors'
import { BlendScriptConfig } from '@script/types'

import { ClientSessionResponse } from '../api/client-session/types'

type Config = Exclude<BlendScriptConfig, 'callbacks'>

export type State = {
  version: string
  instanceId: string
  config: Config
  referrer: string
  session?: ClientSessionResponse
  error?: InternalError
  setError: (error?: InternalError) => void
  setHasLoggedIntoAtLeastOneEmployment: (hasLoggedIntoAtLeastOneEmployment: boolean) => void
  hasLoggedIntoAtLeastOneEmployment: boolean
}

export const useStore = create<State>((set) => {
  return {
    version: '',
    instanceId: '',
    config: {
      publishableKey: '',
      sessionToken: '',
      loginItemIds: [],
    },
    referrer: '',
    setError: (error?: InternalError) => set({ error }),
    setHasLoggedIntoAtLeastOneEmployment: (hasLoggedIntoAtLeastOneEmployment: boolean) =>
      set({ hasLoggedIntoAtLeastOneEmployment }),
    hasLoggedIntoAtLeastOneEmployment: false,
  }
})
